import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, terminate, clearIndexedDbPersistence } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfigValues = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'greycoffee-f7f71.firebaseapp.com',
  projectId: 'greycoffee-f7f71',
  storageBucket: 'greycoffee-f7f71.firebasestorage.app',
  messagingSenderId: '123724465617',
  appId: '1:123724465617:web:247c7c3792fdb87177ccf0',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfigValues);
const auth = getAuth(app);

// Initialize Firestore with error handling
let db;
try {
  db = getFirestore(app);
} catch (error) {
  console.error('Error initializing Firestore:', error);
  // If there's an error, try to clear cached data and reinitialize
  if (typeof window !== 'undefined') {
    clearIndexedDbPersistence(getFirestore(app)).catch(() => {
      // Ignore errors, just trying to clean up
    });
  }
  db = getFirestore(app);
}

const functions = getFunctions(app);
const storage = getStorage(app);

// Cleanup function for development hot reloading
if (process.env.NODE_ENV === 'development') {
  // Clean up on module hot reload
  if (module.hot) {
    module.hot.dispose(async () => {
      try {
        await terminate(db);
      } catch (error) {
        console.warn('Error terminating Firestore:', error);
      }
    });
  }

  // Clean up on page unload
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', async () => {
      try {
        await terminate(db);
      } catch (error) {
        console.warn('Error terminating Firestore on unload:', error);
      }
    });
  }
}

// For any legacy files that import from here.
export { db, auth, functions, storage, app };

export default app;